import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "../features/global/globalSlice";
import paymentReducer from "../features/payment/paymentSlice"
import signupReducer from "../features/signup/signupSlice"
import loginReducer from "../features/login/loginSlice"
import { apiSlice } from "../features/api/apiSlice";

const store = configureStore({
    reducer: {
        global: globalReducer,
        payment: paymentReducer,
        signup: signupReducer,
        login:loginReducer,
        [apiSlice.reducerPath]:apiSlice.reducer
    },
    middleware: (getDefaultMiddleware) => (
        getDefaultMiddleware().concat(apiSlice.middleware)
    )
});

export default store;